import "./style/CoachView.css";

// import logo from "../../assets/eleven.jpg";
// import logo2 from "../../assets/img2.jpg";
import { Link } from "react-router-dom";
// import {FiEdit} from "react-icons/fi";
// import {AiOutlineDelete} from "react-icons/ai";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { isAuthenticated } from "../apicalls/auth";
import {
  addCoachLocationAdmin,
  createCoachPackageAdmin,
  getCoachOverview,
  getTransCoach,
  getTransCoachTotal,
} from "../apicalls/coaches";
import Paginations from "./Paginations";
import NumberFormat from "react-number-format";
import debounce from "lodash.debounce";
import Autocomplete from "react-google-autocomplete";
import { googleApiKey } from "../../constAPI";
import { extractFromAddress } from "../utils";
import PopupForm from "./PopupForm/PopupForm";

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return "-";
  }

  return `$${amount.toFixed(2)}`;
};

const formatDateTime = (value) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString();
};

const formatLessonWindow = (lesson) => {
  const start = lesson.start_date_time_tz || lesson.start_date_time;
  const end = lesson.end_date_time_tz || lesson.end_date_time;
  return `${formatDateTime(start)} to ${formatDateTime(end)}`;
};

const formatPackageRate = (pkg) => {
  if (pkg.rate_per_lesson === null || pkg.rate_per_lesson === undefined) {
    return "-";
  }

  return `${formatCurrency(pkg.rate_per_lesson)} / lesson`;
};

const buildAddressComponents = (components = []) => {
  const houseNumber = extractFromAddress(components, "street_number", "long_name");
  const route = extractFromAddress(components, "route", "long_name");
  const street = houseNumber && route ? `${houseNumber} ${route}` : route;

  return {
    country: extractFromAddress(components, "country", "long_name"),
    street,
    city: extractFromAddress(components, "locality", "long_name"),
    state: extractFromAddress(components, "administrative_area_level_1", "long_name"),
    zip: extractFromAddress(components, "postal_code", "long_name"),
  };
};

function CoachView() {
  const { id } = useParams();
  const user = isAuthenticated();
  const accessToken = user?.access_token;
  const [temp, setTemp] = useState([]);

  const [transaction, setTransaction] = useState([]);
  const [overview, setOverview] = useState(null);
  const [search, setSearch] = useState("");
  const [total, setTotal] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [locationForm, setLocationForm] = useState({
    location_id: "",
    location: "",
    latitude: "",
    longitude: "",
    address_components: {},
  });
  const [packageForm, setPackageForm] = useState({
    name: "",
    description: "",
    lesson_count: "",
    total_price: "",
    validity_months: "0",
    lesson_types_allowed: "private",
  });
  const [locationMessage, setLocationMessage] = useState("");
  const [packageMessage, setPackageMessage] = useState("");
  const [editProfileOpen, setEditProfileOpen] = useState(false);

  const handleChange = (e) => {
    setPerPage(e.target.value);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const deBounceOnChange = debounce(handleSearch, 500);

  const loadOverview = useCallback(() => {
    if (!accessToken) {
      return;
    }

    getCoachOverview(id, accessToken, {
      upcomingPerPage: 10,
      upcomingPage: 1,
      pastPerPage: 10,
      pastPage: 1,
    }).then((data) => {
      setOverview(data);
    });
  }, [accessToken, id]);

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    loadOverview();

    getTransCoach(id, accessToken, PerPage, currentPage, search).then(
      (data) => {
        setTransaction(data);
        console.log(data);
      }
    );

    getTransCoachTotal(accessToken, id).then((data) => {
      setTotal(data);
      let temp2 = [];
      for (let i = currentPage; i <= Math.ceil(data?.length / 10); i++) {
        temp2.push(i * 10);
      }
      setTemp(temp2);
    });
  }, [PerPage, search, currentPage, id, accessToken, loadOverview]);

  const coach = overview?.coach;
  const packages = overview?.packages || [];
  const locations = coach?.locations || [];
  const upcomingLessons = overview?.upcoming_lessons?.data || [];
  const pastLessons = overview?.past_lessons?.data || [];

  const handleLocationFormChange = (event) => {
    const { name, value } = event.target;
    setLocationForm((current) => ({ ...current, [name]: value }));
  };

  const handlePackageFormChange = (event) => {
    const { name, value } = event.target;
    setPackageForm((current) => ({ ...current, [name]: value }));
  };

  const submitLocation = (event) => {
    event.preventDefault();
    setLocationMessage("");

    const payload = locationForm.location_id
      ? { location_id: Number(locationForm.location_id) }
      : {
          location: locationForm.location,
          latitude: locationForm.latitude,
          longitude: locationForm.longitude,
          address_components: locationForm.address_components,
        };

    addCoachLocationAdmin(coach?.user_id, accessToken, payload).then((data) => {
      if (data?.error || data?.details) {
        setLocationMessage(data.error || data.details);
        return;
      }

      setLocationForm({
        location_id: "",
        location: "",
        latitude: "",
        longitude: "",
        address_components: {},
      });
      setLocationMessage("Location added.");
      loadOverview();
    });
  };

  const submitPackage = (event) => {
    event.preventDefault();
    setPackageMessage("");

    const payload = {
      coach_id: coach?.user_id,
      name: packageForm.name,
      description: packageForm.description,
      lesson_count: packageForm.lesson_count,
      total_price: packageForm.total_price,
      validity_months: packageForm.validity_months,
      lesson_types_allowed: packageForm.lesson_types_allowed
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean),
    };

    createCoachPackageAdmin(accessToken, payload).then((data) => {
      if (data?.error || data?.details) {
        setPackageMessage(data.error || data.details);
        return;
      }

      setPackageForm({
        name: "",
        description: "",
        lesson_count: "",
        total_price: "",
        validity_months: "0",
        lesson_types_allowed: "private",
      });
      setPackageMessage("Package created.");
      loadOverview();
    });
  };

  // const indexOfLast = currentPage * PerPage;
  // const indexOfFirst = indexOfLast - PerPage;
  // const current =
  //   transaction.length > 0
  //     ? transaction?.slice(indexOfFirst, indexOfLast)
  //     : transaction;
  const paginate = (number) => {
    setCurrentPage(number);
  };

  return (
    <main>
      <Link to="/Coaches">
        <button id="back_btn">back</button>
      </Link>
      {editProfileOpen ? (
        <PopupForm
          action="Edit"
          coach_id={coach?.id || id}
          setPopup={(value) => {
            setEditProfileOpen(value);
            if (!value) {
              loadOverview();
            }
          }}
        />
      ) : (
        ""
      )}
      <div className="row my-3">
        <div className="col-lg-6 col-md-12">
          <div className="d-flex ">
            <img src={coach?.profile_picture} alt="" className="head_img" />

            <div className="ms-4">
              <h2 className="fw-bold">{coach?.full_name}</h2>

              <span>{coach?.about_me}</span>
              <div className="coach-meta-grid mt-3">
                <div>
                  <span className="coach-meta-label">Email</span>
                  <strong>{coach?.email || "-"}</strong>
                </div>
                <div>
                  <span className="coach-meta-label">Phone</span>
                  <strong>{coach?.phone || "-"}</strong>
                </div>
                <div>
                  <span className="coach-meta-label">Private Rate</span>
                  <strong>{formatCurrency(coach?.price_private || coach?.hourly_rate)}</strong>
                </div>
                <div>
                  <span className="coach-meta-label">Semi-private Rate</span>
                  <strong>{formatCurrency(coach?.price_semi)}</strong>
                </div>
                <div>
                  <span className="coach-meta-label">Group Rate</span>
                  <strong>{formatCurrency(coach?.price_group)}</strong>
                </div>
                <div>
                  <span className="coach-meta-label">Experience</span>
                  <strong>{coach?.experience_years ?? "-"}</strong>
                </div>
                <div>
                  <span className="coach-meta-label">Certifications</span>
                  <strong>{coach?.certifications || "-"}</strong>
                </div>
                <div>
                  <span className="coach-meta-label">Languages</span>
                  <strong>{coach?.other_languages || "-"}</strong>
                </div>
                <div>
                  <span className="coach-meta-label">Stripe</span>
                  <strong>{coach?.charges_enabled ? "Enabled" : "Disabled"}</strong>
                </div>
              </div>
              <button
                className="coaches_button mt-3"
                onClick={() => setEditProfileOpen(true)}
                disabled={!coach?.id && !id}
              >
                Edit Coach
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="overview-grid">
        <section className="overview-panel">
          <h3>Location Search</h3>
          <div className="overview-stat">
            <strong>
              {coach?.location_search?.appears_in_nearby_discovery
                ? "Shows in nearby"
                : coach?.location_search?.appears_in_location_search
                ? "Location only"
                : "Needs fix"}
            </strong>
            <span>
              {coach?.location_search?.searchable_location_count || 0}/
              {coach?.location_search?.location_count || 0} valid locations,{" "}
              {coach?.location_search?.scheduled_location_count || 0} scheduled
            </span>
          </div>
          {coach?.location_search?.issues?.length ? (
            <div className="text-danger small">
              {coach.location_search.issues.join(", ")}
            </div>
          ) : (
            ""
          )}
          <form className="admin-inline-form" onSubmit={submitLocation}>
            <h4>Add Coach Location</h4>
            <input
              name="location_id"
              value={locationForm.location_id}
              onChange={handleLocationFormChange}
              placeholder="Existing location ID"
            />
            <div className="form-divider">or create new</div>
            <Autocomplete
              apiKey={googleApiKey}
              className="admin-autocomplete"
              value={locationForm.location}
              options={{
                types: ["geocode", "establishment"],
                fields: [
                  "name",
                  "address_components",
                  "geometry",
                  "formatted_address",
                ],
              }}
              onPlaceSelected={(place) => {
                if (!place?.geometry?.location) {
                  return;
                }

                const latitude = place.geometry.location.lat();
                const longitude = place.geometry.location.lng();
                const formattedAddress = place.formatted_address || "";
                const location = formattedAddress.startsWith(place.name)
                  ? formattedAddress
                  : [place.name, formattedAddress].filter(Boolean).join(" ");

                setLocationForm((current) => ({
                  ...current,
                  location_id: "",
                  location,
                  latitude,
                  longitude,
                  address_components: buildAddressComponents(place.address_components || []),
                }));
              }}
              onChange={(event) =>
                setLocationForm((current) => ({
                  ...current,
                  location_id: "",
                  location: event.target.value,
                }))
              }
              placeholder="Search courts, parks, clubs..."
            />
            <div className="form-row">
              <input
                name="latitude"
                value={locationForm.latitude}
                onChange={handleLocationFormChange}
                placeholder="Latitude"
              />
              <input
                name="longitude"
                value={locationForm.longitude}
                onChange={handleLocationFormChange}
                placeholder="Longitude"
              />
            </div>
            {locationMessage ? <div className="small">{locationMessage}</div> : ""}
            <button type="submit" disabled={!coach?.user_id}>
              Add Location
            </button>
          </form>
          <div className="mini-list">
            {locations.length ? (
              locations.map((location) => (
                <div key={location.cl_relation_id || location.location_id}>
                  <strong>{location.location}</strong>
                  <span>
                    {location.latitude || "-"}, {location.longitude || "-"} ·{" "}
                    {location.appears_in_nearby_discovery
                      ? "nearby ready"
                      : location.has_valid_coordinates
                      ? "valid coordinates"
                      : "bad coordinates"}
                  </span>
                </div>
              ))
            ) : (
              <p>No attached locations.</p>
            )}
          </div>
        </section>

        <section className="overview-panel">
          <h3>Package Rates</h3>
          <div className="overview-stat">
            <strong>
              {coach?.package_rates?.has_active_packages
                ? `${formatCurrency(coach.package_rates.min_rate_per_lesson)} - ${formatCurrency(
                    coach.package_rates.max_rate_per_lesson
                  )}`
                : "No active packages"}
            </strong>
            <span>
              {coach?.package_rates?.active_package_count || 0} active /{" "}
              {coach?.package_rates?.package_count || 0} total
            </span>
          </div>
          <form className="admin-inline-form" onSubmit={submitPackage}>
            <h4>Create Package</h4>
            <input
              name="name"
              value={packageForm.name}
              onChange={handlePackageFormChange}
              placeholder="Package name"
              required
            />
            <input
              name="description"
              value={packageForm.description}
              onChange={handlePackageFormChange}
              placeholder="Description"
            />
            <div className="form-row">
              <input
                name="lesson_count"
                value={packageForm.lesson_count}
                onChange={handlePackageFormChange}
                placeholder="Lessons"
                required
              />
              <input
                name="total_price"
                value={packageForm.total_price}
                onChange={handlePackageFormChange}
                placeholder="Total price"
                required
              />
            </div>
            <div className="form-row">
              <input
                name="validity_months"
                value={packageForm.validity_months}
                onChange={handlePackageFormChange}
                placeholder="Validity months"
              />
              <input
                name="lesson_types_allowed"
                value={packageForm.lesson_types_allowed}
                onChange={handlePackageFormChange}
                placeholder="private, semi_private, group"
              />
            </div>
            {packageMessage ? <div className="small">{packageMessage}</div> : ""}
            <button type="submit" disabled={!coach?.user_id}>
              Create Package
            </button>
          </form>
          <div className="mini-list">
            {packages.length ? (
              packages.map((pkg) => (
                <div key={pkg.id}>
                  <strong>
                    {pkg.name} {pkg.is_active ? "" : "(inactive)"}
                  </strong>
                  <span>
                    {pkg.lesson_count} lessons · {formatCurrency(pkg.total_price)} ·{" "}
                    {formatPackageRate(pkg)} · {pkg.purchase_count || 0} purchases
                  </span>
                </div>
              ))
            ) : (
              <p>No packages created.</p>
            )}
          </div>
        </section>
      </div>

      <div className="overview-grid">
        <section className="overview-panel">
          <h3>Upcoming Lessons</h3>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Player</th>
                  <th>Time</th>
                  <th>Location</th>
                  <th>Type</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {upcomingLessons.length ? (
                  upcomingLessons.map((lesson) => (
                    <tr key={lesson.id}>
                      <td>{lesson.player_full_name || "Open lesson"}</td>
                      <td>{formatLessonWindow(lesson)}</td>
                      <td>{lesson.location || "-"}</td>
                      <td>{lesson.lesson_type_name || "-"}</td>
                      <td>{lesson.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No upcoming lessons.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>

        <section className="overview-panel">
          <h3>Past Lessons</h3>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Player</th>
                  <th>Time</th>
                  <th>Location</th>
                  <th>Type</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {pastLessons.length ? (
                  pastLessons.map((lesson) => (
                    <tr key={lesson.id}>
                      <td>{lesson.player_full_name || "Open lesson"}</td>
                      <td>{formatLessonWindow(lesson)}</td>
                      <td>{lesson.location || "-"}</td>
                      <td>{lesson.lesson_type_name || "-"}</td>
                      <td>{lesson.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No past lessons.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <div className="coaches_title">
        <h1>Transactions</h1>
      </div>
      <div className="filter">
        {currentPage > 1 ? (
          ""
        ) : (
          <div>
            <select name="" id="" onChange={handleChange}>
              {temp.map((val) => {
                return (
                  <option key={val} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
            <span>
              show {PerPage} out of {total?.length}
            </span>
          </div>
        )}
        <input
          className="w-25"
          type="text"
          onChange={deBounceOnChange}
          placeholder="Search"
        />
      </div>

      <div className="col-11">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Player Name</th>
                <th scope="col">Date</th>
                <th scope="col">Status</th>
                <th scope="col">Amount</th>
              </tr>
            </thead>
            <tbody>
              {transaction.length > 0 ? (
                transaction?.map((trans) => {
                  return (
                    <tr key={trans.id}>
                      <td className="fw-bold d-flex">
                        <span>
                          <img
                            src={trans.profile_picture}
                            alt=""
                            id="table_img"
                          />
                        </span>
                        <span>
                          <span>{trans.full_name} </span>
                          <span style={{ fontSize: "13px" }}>
                            ({new Date(trans.start_date_time).toLocaleString()}{" "}
                            to {new Date(trans.end_date_time).toLocaleString()},{" "}
                            {trans.location})
                          </span>
                        </span>
                      </td>
                      <td>
                        {new Date(trans.transaction_date_time).toLocaleString()}
                      </td>
                      <td
                        className={
                          trans.payment_status === "Success"
                            ? "success fw-bold"
                            : "error fw-bold"
                        }
                      >
                        {trans.payment_status}
                        {trans.is_refund ? (
                          <span className="error" style={{ fontSize: "13px" }}>
                            (refunded)
                          </span>
                        ) : (
                          ""
                        )}
                      </td>
                      <td className="fw-bold">
                        <NumberFormat
                          value={trans.amount / 100}
                          prefix={"$"}
                          displayType={"text"}
                          thousandSeparator={true}
                        ></NumberFormat>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td>
                    <h2>Transaction not Available</h2>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {search ? (
          ""
        ) : (
          <Paginations
            perPage={PerPage}
            total={total?.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        )}
      </div>
    </main>
  );
}

export default CoachView;
